import { render, staticRenderFns } from "./SdsSection3MultiInputForm.vue?vue&type=template&id=0f6b666a&scoped=true"
import script from "./SdsSection3MultiInputForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./SdsSection3MultiInputForm.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SdsSection3MultiInputForm.vue?vue&type=style&index=0&id=0f6b666a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6b666a",
  null
  
)

export default component.exports